import { setLoading } from "src/store/customizer/CustomizerSlice";
import { PostFunction } from "src/utils/axios_connection";
import UrlApi from "src/utils/Url";

export const GetStatistics =
  ({ callback }) =>
  async (dispatch, getState) => {
    try {
      const response = await PostFunction({
        data: {},
        Route: UrlApi.statistics.get,
        showalert: false,
        state: getState,
        dispatch,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const ManageStatistics =
  ({ callback, values, editMode }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      // Backend expects JSON object, not FormData (no file uploads for statistics)
      const data = {};
      
      if (editMode && values?.id) {
        data.id = values.id;
      }
      
      if (values.stat_key) data.stat_key = values.stat_key.trim();
      if (values.label) data.label = values.label.trim();
      if (values.value) data.value = values.value.trim();
      if (values.icon) data.icon = values.icon.trim();
      if (values.display_order !== undefined) data.display_order = values.display_order;
      if (values.is_active !== undefined) data.is_active = Boolean(values.is_active);

      const route = editMode ? UrlApi.statistics.edit : UrlApi.statistics.add;
      
      const response = await PostFunction({
        data: data,
        Route: route,
        showalert: true,
        state: getState,
        isMultipart: false, // Backend expects JSON, not FormData
        dispatch,
      });
      
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };

export const EditStatistics =
  ({ callback, id, nameFailed, dataFailed }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      // Use JSON object instead of FormData for inline edits (no file uploads)
      const data = {
        id: id,
        [nameFailed]: nameFailed === "is_active" 
          ? Boolean(dataFailed) 
          : dataFailed
      };
      
      const response = await PostFunction({
        data: data,
        Route: UrlApi.statistics.edit,
        showalert: true,
        state: getState,
        isMultipart: false,
        dispatch,
      });
      
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };

export const DeleteStatistics =
  ({ callback, id }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      const response = await PostFunction({
        data: { ids: id },
        Route: UrlApi.statistics.delete,
        showalert: true,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });
      
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };

